/*global $:false*/

// Model responsible for storing a user setting entry
var UserSettingM = function(core, module, category, key) {
    this._core = core;
    this._id = null;
    this._version = null;
    this._user = null;
    this._isShared = false;

    this._module = module;
    this._category = category;
    this._key = key;

    this._value = null;
};

UserSettingM.prototype.setId = function(id) {
    this._id = id;
};

UserSettingM.prototype.getId = function() {
    return this._id;
};

UserSettingM.prototype.isSystemSetting = function() {
    return this._user === "system";
};

UserSettingM.prototype.isOwnedByUser = function() {
    return this._user === this._core.getCurrentLoggedInUser();
};

UserSettingM.prototype.isShared = function() {
    return this._isShared;
};

UserSettingM.prototype.setShared = function(shared) {
    this._isShared = shared;
};

UserSettingM.prototype.setValue = function(value) {
    this._value = JSON.stringify(value);
};

UserSettingM.prototype.getValue = function() {
    return JSON.parse(this._value);
};

UserSettingM.prototype.setKey = function(key) {
    this._key = key;
};

UserSettingM.prototype.getOwner = function() {
    return this._user;
};

UserSettingM.prototype.getKey = function() {
    return this._key;
};

UserSettingM.prototype.save = function(opts) {
    var _this = this,
        endpointPath = "user/settings";

    var data = {
        id: this._id,
        version: this._version,
        module: this._module,
        category: this._category,
        key: this._key,
        value: this._value,
        isShared: this._isShared
    };

    $.ajax({
        url: endpointPath,
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify(data),
        success: function(data) {
            _this._id = data.id;
            _this._user = data.user;
            _this._isShared = data.isShared;
            _this._version = data.version;

            if(opts.success) opts.success(_this);
        },
        error: function(req) {
            window.console.log("SETTING: " + _this._module + ":" + _this._category + ":" + _this._key +
                               ":error-save: " + req.status + " : " + req.statusText + ":" + req.responseText);

            if(opts.error) opts.error(req.status);
        }
    });
};

UserSettingM.prototype.share = function(opts) {
    var _this = this,
        endpointPath = "user/settings/share/" + this._id;

    $.ajax({
        url: endpointPath,
        type: "PUT",
        success: function(data) {
            _this._isShared = true;
            _this._version = data.version;

            if(opts.success) opts.success(_this);
        },
        error: function(req) {
            window.console.log("SETTING: " + _this._module + ":" + _this._category + ":" + _this._key +
                               ":error-share: " + req.status + " : " + req.statusText + ":" + req.responseText);

            if(opts.error) opts.error(req.status);
        }
    });
};

UserSettingM.prototype.unshare = function(opts) {
    var _this = this,
        endpointPath = "user/settings/unshare/" + this._id;

    $.ajax({
        url: endpointPath,
        type: "PUT",
        success: function(data) {
            _this._isShared = false;
            _this._version = data.version;

            if(opts.success) opts.success(_this);
        },
        error: function(req) {
            window.console.log("SETTING: " + _this._module + ":" + _this._category + ":" + _this._key +
                               ":error-unshare: " + req.status + " : " + req.statusText + ":" + req.responseText);

            if(opts.error) opts.error(req.status);
        }
    });
};


UserSettingM.prototype.deleteSelf = function(opts) {
    var _this = this,
        endpointPath = "user/settings/" + this._id;

    $.ajax({
        url: endpointPath,
        type: 'DELETE',
        contentType: "application/json",
        success: function() {
            if (opts.success) opts.success(_this._id);
        },
        error: function(req) {
            window.console.log("SETTING:DELETE:ERROR: " + req.status + " : " + req.statusText + ":" + req.responseText);

            if(opts.error) opts.error(req.status);
        }
    });
};

//
// Load all user settings for the module and category.
// The user settings will be returned in the callback function `successFn` as an argument.
//
UserSettingM.loadAll = function(core, module, category, opts) {
    var endpointPath = "user/settings/" + module + "/" + category,
        _loadingKey = core.getLoadingKey();

    if(opts && opts.userSettingsBaseUrl){
        endpointPath = opts.userSettingsBaseUrl + (opts.userSettingsBaseUrl.endsWith("/") ? "" : "/") +  endpointPath;
    }

    core.showLoading(_loadingKey, 'load user settings ' + module + '/' + category);

    $.ajax({
        url: endpointPath,
        type: 'GET',
        contentType: "application/json",
        success: function(data) {
            var settings = [];

            data.forEach(function(entry) {
                var setting = new UserSettingM(core, entry.module, entry.category, entry.key);

                setting.setValue(JSON.parse(entry.value));

                setting._id = entry.id;
                setting._version = entry.version;
                setting._user = entry.user;
                setting._isShared = entry.isShared;

                settings.push(setting);
            });

            if (opts.success) opts.success(settings);
        },
        error: function(req) {
            window.console.log("SETTING:LOAD-ALL:ERROR: " + req.status + " : " + req.statusText + ":" + req.responseText);

            if(opts.error) opts.error(req.status);
        },
        complete: function() {
            core.hideLoading(_loadingKey, 'load user settings ' + module + '/' + category);
        }
    });
};

export default UserSettingM;
